import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      style={{
        background: '#475569',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
      }}
      className="site-footer"
      data-track-view="view_footer"
      data-element-name="footer"
    >
      <div style={{ padding: 'clamp(42px, 5vw, 52px) 40px 14px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {/* Brand */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontWeight: 900, fontSize: '20px', color: '#fa7c9e', marginBottom: '4px' }}>
            ニジ看護転職
          </p>
          <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)' }}>
            厚生労働大臣許可証 13-ユ-317878
          </p>
        </div>

        {/* Links */}
        <nav
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '24px',
            flexWrap: 'wrap',
          }}
        >
          <a
            href="https://nijikango.co.jp/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', fontSize: '14px', textDecoration: 'none' }}
          >
            運営会社
          </a>
          <Link to="/terms-of-service" style={{ color: 'white', fontSize: '14px', textDecoration: 'none' }}>
            利用規約
          </Link>
          <Link to="/privacy-policy" style={{ color: 'white', fontSize: '14px', textDecoration: 'none' }}>
            プライバシーポリシー
          </Link>
        </nav>

        {/* Copyright */}
        <p style={{ textAlign: 'center', fontSize: '12px', color: 'rgba(255,255,255,0.7)', paddingBottom: '8px' }}>
          &copy; {new Date().getFullYear()} 株式会社ニジ看護転職
        </p>
      </div>
    </footer>
  );
}
